import React from "react";
import { Route, Switch } from "react-router-dom";
import ChatList from "./ChatList";

const App = ({ match }) => (
  <Switch>
    <Route exact path={`${match.url}`} component={ChatList} />
  </Switch>
);

export default App;
